import { Navigate, Outlet } from "react-router";
import { Spin } from "antd";
import { canAccessCms } from "./permissions";

const ProtectedRoutes = ({ children, loggedInUser, isLoading }) => {
  if (isLoading) {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spin />
      </div>
    );
  }

  if (!canAccessCms(loggedInUser)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoutes;
